import React from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  CloseButton,
} from '@chakra-ui/react';
import styled from 'styled-components';

import { LinkButton } from '../../subscriptions/SubsDetail.components';
import dayjs from 'dayjs';

interface MerchantBannerProps {
  onClose: () => void;
  title?: string;
  description?: string;
  ctaButtonText?: string;
  ctaButtonUrl?: string;
  type?: 'info' | 'warning' | 'success' | 'error';
  subscription: Subscription;
  isDismissable: boolean;
}
export const MerchantBanner = ({
  onClose,
  title,
  description,
  ctaButtonText,
  ctaButtonUrl,
  type,
  subscription,
  isDismissable,
}: MerchantBannerProps) => {
  return (
    <MerchantBannerContainer>
      <Alert
        status={type}
        className="awt-merchant-banner-alert"
        variant="solid"
      >
        <AlertIcon className="awt-merchant-banner-icon" marginRight="13px" />
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          className="awt-merchant-banner-body-contaienr"
        >
          {title && (
            <AlertTitle
              paddingBottom="8px"
              className="awt-merchant-banner-title"
            >
              {title}
            </AlertTitle>
          )}
          {description && (
            <AlertDescription className="awt-merchant-banner-description">
              {description.replaceAll(
                '$nextBillingDate',
                dayjs(subscription.NextBillingDate).format('YYYY/MM/DD'),
              )}
            </AlertDescription>
          )}
        </Box>
        {ctaButtonText && (
          <MerchantBannerButtonContainer>
            <LinkButton
              className="subscription-payment-link-button"
              href={ctaButtonUrl}
              target="_blank"
            >
              {ctaButtonText}
            </LinkButton>
          </MerchantBannerButtonContainer>
        )}

        {isDismissable && (
          <CloseButton
            className="awt-merchant-banner-close-button"
            alignSelf="flex-start"
            position="relative"
            right={-1}
            top={-1}
            marginLeft="13px"
            marginTop="3px"
            onClick={onClose}
          />
        )}
      </Alert>
    </MerchantBannerContainer>
  );
};

const MerchantBannerContainer = styled.div.attrs({
  className: 'awt-merchant-banner-container',
})`
  padding-bottom: 12px;
`;

const MerchantBannerButtonContainer = styled.div.attrs({
  className: 'awt-merchant-banner-button-container',
})`
  padding: 8px;
  flex-shrink: 0;
`;
